// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner2Container {
  display: flex;
  padding: 80px 13.103%;
  flex-direction: column;
  align-items: center;
  background: var(--Black, #101010);
}

.banner2InnerContainer {
  gap: 24px;
  display: flex;
  max-width: 1150px;
  padding: 36px 64px 36px 40px;
  justify-content: space-between;
  align-items: center;
  align-self: center;
  border-radius: 24px;
  background: var(--Brand-Light, #FFF2F2);
}

.banner2MainContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  flex: 1 0 0;
}

.banner2ImgContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 129.563px;
  height: 210px;
  padding: 13.018px;
}

.banner2Main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  flex: 1 0 0;
}

.banner2Heading {
  color: #000;
  font-family: "General Sans";
  font-size: 36px;
  font-style: normal;
  font-weight: 600;
  line-height: 123%;
}

.banner2Subtitle {
  color: var(--Black, #101010);
  font-family: "General Sans";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

@media screen and (max-width: 650px) {
  .banner2Container {
    display: flex;
    padding: 0;
    flex-direction: column;
    align-items: center;
  }
  .banner2InnerContainer {
    display: flex;
    flex-direction: column;
    gap: 24px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    border-radius: 0;
    padding: 36px 24px;
    background: var(--Brand-Light, #FFF2F2);
  }
  .banner2MainContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
    align-self: stretch;
  }
  .banner2ImgContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
  }
  .banner2Img {
    width: 129.563px;
    height: 176.206px;
  }
  .banner2Main {
    display: flex;
    padding: 0px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
  }
  .banner2Heading {
    text-align: center;
    font-family: "General Sans";
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 135%; /* 32.4px */
  }
  .banner2Subtitle {
    text-align: center;
    font-family: "General Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 19.6px */
  }
  .btn_c {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/landing-page/components/banner2/style.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iCAAA;AACJ;;AAEA;EAGI,SAAA;EACA,aAAA;EACA,iBAAA;EACA,4BAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uCAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;AADJ;;AAIA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;AADJ;;AASA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;AANJ;;AASA;EACI,WAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AANJ;;AASA;EACI,4BAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AANJ;;AASA;EACI;IACI,aAAA;IACA,UAAA;IACA,sBAAA;IACA,mBAAA;EANN;EASF;IACI,aAAA;IACA,sBAAA;IACA,SAAA;IACA,8BAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;IACA,kBAAA;IACA,uCAAA;EAPF;EAUF;IACI,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,mBAAA;IACA,SAAA;IACA,mBAAA;EARF;EAWF;IACI,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,UAAA;EATF;EAYF;IACI,gBAAA;IACA,iBAAA;EAVF;EAaF;IACI,aAAA;IACA,iBAAA;IACA,sBAAA;IACA,uBAAA;IACA,mBAAA;IACA,QAAA;IACA,mBAAA;EAXF;EAcF;IACI,kBAAA;IACA,2BAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA,EAAA,WAAA;EAZF;EAeF;IACI,kBAAA;IACA,2BAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA,EAAA,WAAA;EAbF;EAgBF;IACI,WAAA;EAdF;AACF","sourcesContent":[".banner2Container{\n    display: flex;\n    padding:80px 13.103%;\n    flex-direction: column;\n    align-items: center;\n    background: var(--Black, #101010);\n}\n\n.banner2InnerContainer{\n    // margin-left: auto;\n    // margin-right: auto;\n    gap:24px;\n    display: flex;\n    max-width: 1150px;\n    padding: 36px 64px 36px 40px;\n    justify-content: space-between;\n    align-items: center;\n    align-self: center;\n    border-radius: 24px;\n    background: var(--Brand-Light, #FFF2F2);\n}\n\n.banner2MainContainer{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 24px;\n    flex: 1 0 0;\n}\n\n.banner2ImgContainer{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 129.563px;\n    height: 210px;\n    padding: 13.018px;\n}\n\n// .banner2Img{\n    \n//     height: 176.206px;\n// }\n\n.banner2Main{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    gap: 12px;\n    flex: 1 0 0;\n}\n\n.banner2Heading{\n    color: #000;\n    font-family: \"General Sans\";\n    font-size: 36px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 123%;\n}\n\n.banner2Subtitle{\n    color: var(--Black, #101010);\n    font-family: \"General Sans\";\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n}\n\n@media screen and (max-width: 650px) {\n    .banner2Container{\n        display: flex;\n        padding: 0;\n        flex-direction: column;\n        align-items: center;\n    }\n\n.banner2InnerContainer{\n    display: flex;\n    flex-direction: column;\n    gap:24px;\n    justify-content: space-between;\n    align-items: center;\n    align-self: stretch;\n    border-radius: 0;\n    padding: 36px 24px;\n    background: var(--Brand-Light, #FFF2F2);\n}\n\n.banner2MainContainer{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 24px;\n    align-self: stretch;\n}\n\n.banner2ImgContainer{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0;\n}\n\n.banner2Img{\n    width: 129.563px;\n    height: 176.206px;\n}\n\n.banner2Main{\n    display: flex;\n    padding: 0px 24px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    align-self: stretch;\n}\n\n.banner2Heading{\n    text-align: center;\n    font-family: \"General Sans\";\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 135%; /* 32.4px */\n}\n\n.banner2Subtitle{\n    text-align: center;\n    font-family: \"General Sans\";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 140%; /* 19.6px */\n}\n\n.btn_c{\n    width: 100%;\n}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
